/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Raster } from "./Raster";
import { RasterFromJSON, RasterFromJSONTyped, RasterToJSON, RasterToJSONTyped } from "./Raster";

/**
 *
 * @export
 * @interface PaginatedRasterList
 */
export interface PaginatedRasterList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<Raster>;
}

/**
 * Check if a given object implements the PaginatedRasterList interface.
 */
export function instanceOfPaginatedRasterList(value: object): value is PaginatedRasterList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedRasterListFromJSON(json: any): PaginatedRasterList {
  return PaginatedRasterListFromJSONTyped(json, false);
}

export function PaginatedRasterListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedRasterList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(RasterFromJSON),
  };
}

export function PaginatedRasterListToJSON(json: any): PaginatedRasterList {
  return PaginatedRasterListToJSONTyped(json, false);
}

export function PaginatedRasterListToJSONTyped(
  value?: PaginatedRasterList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(RasterToJSON),
  };
}
